export const GET_ALL_PERMISSIONS = "GET_ALL_PERMISSIONS"
export const GET_ALL_PERMISSIONS_RESPONSE_SUCCESS =
  "GET_ALL_PERMISSIONS_RESPONSE_SUCCESS"

export const CREATE_PERMISSION_NAME = "CREATE_PERMISSION_NAME"
export const CREATE_ROLE_RESPONSE_SUCCESS = "CREATE_ROLE_RESPONSE_SUCCESS"

export const DELETE_PERMISSION = "DELETE_PERMISSION"
export const DELETE_PERMISSION_RESPONSE_SUCCESS =
  "DELETE_PERMISSION_RESPONSE_SUCCESS"
export const DELETE_PERMISSION_RESPONSE_ERROR =
  "DELETE_PERMISSION_RESPONSE_ERROR"

export const EDIT_PERMISSION = "EDIT_PERMISSION"
export const EDIT_PERMISSION_RESPONSE_SUCCESS =
  "EDIT_PERMISSION_RESPONSE_SUCCESS"
export const EDIT_PERMISSION_RESPONSE_ERROR = "EDIT_PERMISSION_RESPONSE_SUCCESS"
